import React, { useEffect, useState } from "react";
import { usePageTitleContext } from "../../contexts/PageTitle";
import { useIframe } from "../../hooks";


export const IframeAbm = (props) => {

  const { panels, caption, bodyColor } = props;
  const [state, setState] = useState({loaded: false})
  const { setPageTitle } = usePageTitleContext();
  const { resolveMatches } = useIframe();

  useEffect(()=>{
    setPageTitle(caption, "", bodyColor);
    setState({...state, loaded: true});
  }, [])

  return (
    <>
      <div class="container">
        {state.loaded && 
          panels.map(row => {
            return (
              <div class="row">
                {
                  row.map(panel => {
                    const src = resolveMatches(`${panel.src}`);
                    return (
                      <div className={panel.columnClass || `col-${panel.columns}`}>
                        <iframe width="100%" style={{border: "0px"}} {...panel} src={src}></iframe>
                      </div>
                    )
                  })
                }
              </div>
            )

          })
        }
      </div>
    </>
  );
}
